module.exports = __webpack_public_path__ + "img/问大家示例图.76c90017.jpeg";